import { render, staticRenderFns } from "./profileLayout.vue?vue&type=template&id=4b104b1c"
import script from "./profileLayout.vue?vue&type=script&lang=js"
export * from "./profileLayout.vue?vue&type=script&lang=js"
import style0 from "./profileLayout.vue?vue&type=style&index=0&id=4b104b1c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileHeader: require('/home/hitaxi/domains/app.hitaxivipairport.com/front-end/components/ProfileHeader.vue').default})
